module.exports = __webpack_public_path__ + "static/media/face-despair.5f7b7bc9.webp";